/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import AbstractResponsiveComponent from './AbstractResponsiveComponent';

class BannerCategoryContent extends Component {
	view() {
		return <div className={this.attrs.className}>{m.trust(this.attrs.deviceData)}</div>;
	}
}

export default class BannerCategory extends AbstractResponsiveComponent {
	get data() {
		return this.attrs.banner.content()?.category;
	}

	getClassName() {
		return `${super.className} BannerCategory`;
	}

	get content() {
		return BannerCategoryContent;
	}
}
